import { apiClient } from "@base/api/client";
import { type UseMutationOptions, useMutation } from "@tanstack/react-query";
import {
  type DailyLogSubmitRequest,
  type DailyLogSubmitResponse,
  dailyLogSubmitResponseSchema,
} from "./submitDailyLogSchema";

async function submitDailyLog(projectId: string, body: DailyLogSubmitRequest): Promise<DailyLogSubmitResponse> {
  const response = await apiClient.post<unknown>(`/project-management/api/projects/${projectId}/daily-logs`, body);
  return dailyLogSubmitResponseSchema.parse(response.data);
}

export function useSubmitDailyLogMutation(
  projectId: string,
  options?: Omit<UseMutationOptions<DailyLogSubmitResponse, Error, DailyLogSubmitRequest>, "mutationFn">,
) {
  return useMutation({
    mutationFn: (body: DailyLogSubmitRequest) => submitDailyLog(projectId, body),
    ...options,
  });
}
